import * as React from "react";

interface props {
  className?: string;
  fill?: any;
}
const VerifiedIcon = ({ className, fill = "#262626" }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="26"
    height="26"
    fill="none"
    viewBox="0 0 27 26"
  >
    <rect
      width="25.5"
      height="25.5"
      x="0.75"
      y="0.25"
      fill="#none"
      rx="12.75"
    ></rect>
    <rect
      width="25.5"
      height="25.5"
      x="0.75"
      y="0.25"
      stroke={fill}
      strokeWidth="0.5"
      rx="12.75"
    ></rect>
    <path
      fill={fill}
      d="M14 5a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m3.512 6.59-4.307 4.307a.616.616 0 0 1-.871 0l-1.846-1.846a.616.616 0 0 1 .87-.871l1.411 1.412 3.873-3.873a.615.615 0 1 1 .87.87"
    ></path>
  </svg>
);

export default VerifiedIcon;
